export enum SensorState {
  STOPPED = 'STOPPED',
  ACTIVE = 'ACTIVE',
  ERROR_MAXIMUM = 'ERROR_MAXIMUM',
  ERROR_MINIMUM = 'ERROR_MINIMUM',
  ERROR = 'ERROR'
}

export enum SensorGroupType {
  NONE = 'NONE',
  SECTOR = 'SECTOR',
  PARCEL = 'PARCEL',
  VISUALIZATION_GROUP = 'VISUALIZATION_GROUP'
}